import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from '../../base/api-service-base';
import { OrderPaymentStatusReferenceModel } from "../../models/reference-model/reference-general-model/order-payment-status-reference.model";

@Injectable({
  providedIn: 'root'
})
export class OrderPaymentStatusReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/OrderPaymentStatusReferences";

  constructor(private httpClient: HttpClient,
    private authService: AuthService) {
      super(httpClient, authService);
  }

  public getOrderPaymentStatusReference(): Observable<OrderPaymentStatusReferenceModel[]> {
    return this.httpGet<OrderPaymentStatusReferenceModel[]>(this.PATH, null)
      .pipe(
        map(
          response => response.body
        )
      )
  }
}
